import { BaseActionEnum } from "../action-menu/ActionMenuItem";
import { getActionMenuItems } from "../action-menu/BaseActions";


const actionEnums = [
    BaseActionEnum.MyProfile,
    BaseActionEnum.AppPreferences,
    BaseActionEnum.MenuVisibility,    
    BaseActionEnum.ChangeCustomer,
    BaseActionEnum.Signout,

    BaseActionEnum.LastRefresh,
    BaseActionEnum.LastSync,
    BaseActionEnum.OfflineMode,



    BaseActionEnum.ContactSupport,
    BaseActionEnum.SearchHelp,
    BaseActionEnum.GetRemoteSupportCode,

    BaseActionEnum.Version,
    BaseActionEnum.RecentUpdates,
    BaseActionEnum.SubmitProductIdea,

    BaseActionEnum.HardwareOrder,
    //BaseActionEnum.Terms,
    //BaseActionEnum.PrivacyPolicy,
];

export const appHeaderActionItems = getActionMenuItems(actionEnums);
